import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { useLanguage } from '../contexts/LanguageContext';
export function ImpressumPage() {
  const {
    language
  } = useLanguage();
  const isGerman = language === 'de';
  return <div className="min-h-screen bg-[#0a0e1a]" data-id="element-580">
      <Navigation data-id="element-581" />
      <main className="pt-24 pb-16" data-id="element-582">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-583">
          <h1 className="text-4xl font-bold text-white mb-12" data-id="element-584">
            {isGerman ? 'Impressum' : 'Imprint'}
          </h1>

          <div className="prose prose-invert max-w-none" data-id="element-585">
            <section className="mb-8" data-id="element-586">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-587">
                {isGerman ? 'Adresse' : 'Address'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-588">
                CRM Kraft LLC
                <br data-id="element-589" />
                {isGerman ? 'Vertreten durch: Justus Kraft' : 'Represented by: Justus Kraft'}
                <br data-id="element-590" />
                7901 4th St. N, Ste. 300
                <br data-id="element-591" />
                St. Petersburg, FL 33702
                <br data-id="element-592" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-593">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-594">
                {isGerman ? 'Kontakt' : 'Contact'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-595">
                {isGerman ? 'Telefon' : 'Phone'}: +49 157 35999071
                <br data-id="element-596" />
                {isGerman ? 'E-Mail' : 'Email'}: justus@crm-kraft.de
              </p>
            </section>

            <section className="mb-8" data-id="element-597">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-598">
                {isGerman ? 'EU-Streitschlichtung' : 'EU Dispute Resolution'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-599">
                {isGerman ? 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: ' : 'The European Commission provides a platform for online dispute resolution (ODR): '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#ff6b35] hover:underline" data-id="element-600">
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br data-id="element-601" />
                {isGerman ? 'Unsere E-Mail-Adresse finden Sie oben im Impressum.' : 'You can find our email address above in this imprint.'}
              </p>
            </section>

            <section data-id="element-602">
              <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-603">
                {isGerman ? 'Verbraucherstreitbeilegung/Universalschlichtungsstelle' : 'Consumer Dispute Resolution / Universal Arbitration Board'}
              </h2>
              <p className="text-gray-400 leading-relaxed" data-id="element-604">
                {isGerman ? 'Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.' : 'We are neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.'}
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer data-id="element-605" />
    </div>;
}